var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    fill: "#FFAA00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.478,346.793c-45.769-45.773-91.768-91.77-137.682-137.686l91.558-117.72c6.492,5.31,16.038,5.013,22.09-1.041 c6.455-6.453,6.455-16.919,0-23.372c-6.451-6.454-16.917-6.454-23.368,0c-6.057,6.056-6.354,15.602-1.046,22.091l-117.714,91.562 c-42.218-42.216-84.315-84.315-126.027-126.027c-3.143-3.143-6.536-4.287-9.842-3.883c-1.868,0.139-3.666,0.69-5.441,2.007 c-1.533,1.047-2.792,2.37-3.789,3.934c-23.207,27.188-21.619,63.85-12.463,96.787c14.605,52.537,50.029,99.02,87.664,137.295 c36.971,37.595,82.151,69.182,132.325,86.119c34.488,11.636,75.638,13.375,103.896-12.696 C449.606,359.574,449.114,351.428,444.478,346.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.497,347.308c-15.174-11.486-29.848-24.341-43.804-38.534c-15.596-15.86-29.257-31.486-41.093-46.979 c-28.317,62.117-56.634,125.193-84.951,187.307c-2.52,5.531,0.391,13.398,7.135,13.398c55.086,0,110.171,0,165.258,0 c1.406,0,2.614-1.267,3.649-1.763c2.875-0.948,5.029-3.903,4.614-7.946C242.702,417.791,239.1,382.309,235.497,347.308z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarIcon);
export default __webpack_public_path__ + "static/media/radar-icon.886189c6d6546be366ff4fc562d01421.svg";
export { ForwardRef as ReactComponent };